/**************************************************
 * Nombre:       Formulario_Comision_Ver_Consultor
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {Money} from "@mui/icons-material";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {useEffect, useState} from "react";

const Formulario_Comision_Ver_Consultor = ({...props}) => {
    const [esDistribuidor, setEDistribuidor] = useState(false);

    useEffect(() => {

        let es = props.props.getValues('rango');

        let dox = props.props.getValues();
        console.log(dox)

        if (es === 'Distribuidor') {
            setEDistribuidor(true);
        } else {
            setEDistribuidor(false);
        }

    }, [props.props.watch('distribuidor')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1, mt: 2}}>
                    <Typography>Comisiones y valores</Typography>
                </Grid>


                <Grid container size={12}>
                    <IngresoDinero Icono={Money} nombre={'Comision para mi consultor'}
                                   dato={'valorComisionConsultor'} {...props} editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoDinero Icono={Money} nombre={'Mi comision de venta'}
                                   dato={'valorComisionVenta'} {...props} editable={false}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoDinero Icono={Money} nombre={'Recaudo para distribuidor'}
                                   dato={'valorRecaudoDistribuidor'} {...props} editable={false}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Comision_Ver_Consultor

